import { ThemeService } from './../theme-service/theme.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';

@Component({
	selector: 'app-main-title',
	templateUrl: './main-title.component.html',
	styleUrls: ['./main-title.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class MainTitleComponent implements OnInit {
	primaryColor: any;
	isOpenBank: boolean;

	@Input() title;

	@Input() subtitle;

	constructor(private themeService: ThemeService) { }

	ngOnInit() {

		// this.themeService.fetchThemeConfigs(true);
		// this.isOpenBank = this.themeService.isOpenBank();

		if (this.themeService.themeConfigs) {
			this.primaryColor = this.themeService.CorPrimaria ? this.themeService.CorPrimaria : '';
		}
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/main-title/main-title.component.ts